import { render, staticRenderFns } from "./catequest_base_list.vue?vue&type=template&id=5f206c35"
import script from "./catequest_base_list.vue?vue&type=script&lang=js"
export * from "./catequest_base_list.vue?vue&type=script&lang=js"
import style0 from "./catequest_base_list.vue?vue&type=style&index=0&id=5f206c35&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports